module.exports = __webpack_public_path__ + "img/no_borders.17b8cf1c.jpg";